module.exports = __webpack_public_path__ + "static/whiteknitcardi-a445eda3dddb4dc758ee8b409b16991b.jpeg";